// import logo from "../public/vasuki-logo.svg";

import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Login from "./pages/login";
import Admin from "./pages/adminPage";
import Investor from "./pages/investorPage";
import Distributor from "./pages/distributorPage";
import Employee from "./pages/employeePage";
import ForgotPassword from "./pages/forgotPassword";
import {Dashboard} from "./pages/investorPage/Dashboard";
import { DataTable } from "./component/table/dataTable";
import { BreadCrumbProvider } from "./component/ui/breadcrumb";
import InvestorEditUser from "./pages/adminPage/InvestorEditUser";
import { UserManagement } from "./pages/adminPage/UserManagement";
import InvestorUploadReports from "./component/investor/InvestorUploadReports";
import { SchemeView } from "./component/scheme/SchemeView";
import CreateInvestor from "./component/userManagement/investor/createInvestor";
import CreateDistributor from "./component/userManagement/distributor/createDistributor";
import CreateEmployee from "./component/userManagement/employee/createEmployee";
import LoaderGlobal from "./global/LoaderGlobal";
import ToastGlobal from "./global/ToastGlobal";
import Investors from "./pages/adminPage/Investors";
import Schemes from "./pages/adminPage/Schemes";
import { UploadData } from "./pages/adminPage/UploadData";
import EmailTemplate from "./pages/adminPage/EmailTemplates";
import Ticker from "./pages/adminPage/Ticker";
import AddEmailTemplate from "./component/email template/addEmailTemplate";
import AddTicker from "./component/ticker/addTicker";
import Profile from "./component/profile";
import EmailEditorForEmailTemplate from "./component/ui/emailEditor";
import { useSelector } from "react-redux";
import { useEffect } from "react";


function App() {
  const userInfo=useSelector(state=>state.user)
  const navigate=useNavigate()
  const location =useLocation()
  useEffect(() => {
    if(location.pathname.startsWith("/forgot-password")){
      return
    }
    if (userInfo && userInfo.user_type) {
      const userPaths = {
        admin: "/admin",
        investor: "/investor",
        distributor: "/distributor",
        employee: "/employee"
      };
      const defaultPath = userPaths[userInfo.user_type];
      
      // Redirect to the appropriate page if the user is accessing an unauthorized path
      if (!location.pathname.startsWith(defaultPath)) {
        navigate(defaultPath);
      }
      
    } else {
      // Redirect to login if no user info is found
      navigate("/");
       
    }
  }, [userInfo, location.pathname, navigate]);

  return (
 <>
 <LoaderGlobal/>
 <ToastGlobal/>
    <div className="App">
      
      {/* <img src="/vasuki-logo.svg" className="vasuki-logo" alt="logo" />
      <h1 className=' text-red-600 ' >
huiiiiiiiiiiii
      </h1> */}

          {/* <Login></Login> */}
          <Routes>
            
            <Route path="/" element={<Login/>}/>
  
    <Route path="/admin" element={<Admin/>}>
            <Route path="investors" element={<Investors />} />
          <Route path="schemes" element={<Schemes />} />
          <Route path="user-management" element={<UserManagement />} />
          <Route path="upload-data" element={<UploadData />} />
          <Route path="email-templates" element={<EmailTemplate/>} />
          <Route path="ticker" element={<Ticker />} />
          <Route path="investor-upload-report" element={<InvestorUploadReports/>} />
          <Route path="scheme-view" element={<SchemeView/>} />
          <Route path="scheme-edit" element={<SchemeView/>} />
          <Route path="investor-view-user" element={<CreateInvestor/>} />
          <Route path="email-template-view" element={<AddEmailTemplate/>} />
          <Route path="distributor-view-user" element={<CreateDistributor/>} />
          <Route path="employee-view-user" element={<CreateEmployee/>} />
          <Route path="ticker-view" element={<AddTicker/>} />
          <Route path="profile" element={<Profile/>} />
</Route>

           
      
           <Route path="/investor" element={<Investor/>} >
            <Route path="profile" element={<Profile/>} />
            </Route>
            {/* <Route path="/investor/dashboard" element={<Dashboard />} /> */}
            
          
              <Route path="/distributor" element={<Distributor/>} >
            <Route path="profile" element={<Profile/>} />
            </Route>
           
            <Route path="component/table" element={<DataTable/>} />
            <Route path="component/email-editor" element={<EmailEditorForEmailTemplate/>} />
            <Route path="component/investor-edit-user" element={<InvestorEditUser/>} />
            <Route path="/component/scheme-view" element={<SchemeView/>} />
            <Route path="component/user-management" element={<UserManagement/>} />
        
            <Route path="/employee" element={<Employee/>} >
            <Route path="investor-view-user" element={<CreateInvestor/>} />
            <Route path="investor-upload-report" element={<InvestorUploadReports/>} />
            <Route path="scheme-view" element={<SchemeView/>} />
            <Route path="profile" element={<Profile/>} />
            <Route path="email-template-view" element={<AddEmailTemplate/>} />
            <Route path="ticker-view" element={<AddTicker/>} />
            <Route path="scheme-edit" element={<SchemeView/>} />
            </Route>
            <Route path="/forgot-password" element={<ForgotPassword/>} />
          <Route path="/profile" element={<Profile/>} />
          </Routes>

  </div>
 </>
  );
}

export default App;
